import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../security/authentication.service';


@Injectable()
export class CorsInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let clonedRequest = request.clone({
            setHeaders: {
                'Access-Control-Allow-Origin': 'http://localhost:4200',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        return next.handle(clonedRequest);
    }
}
